
import React from "react";
import { useAuth } from "./hooks/useAuth";
import PublicMap from "./components/PublicMap/PublicMap";
import "./globals.css";
import AdminArea from "@/components/AdminArea/AdminArea";

const App: React.FC = () => {
    const { isAuthenticated, hasError } = useAuth();

    const rootDiv = document.getElementById("root");
    const isAdmin = rootDiv?.dataset.isAdmin === "true";

    if (hasError) {
        return <div style={{ backgroundColor: "red", color: "white", padding: "20px" }}>Ошибка авторизации</div>;
    }

    if (!isAuthenticated) {
        return <div>Загрузка...</div>;
    }

    return (
        <div>
            {isAdmin ? (
                <>
                    <AdminArea />
                </>
            ) : (
                <PublicMap />
            )}
        </div>
    );
};

export default App;
